export function getVersion() {
    return { appVersion: __APP_VERSION__ }; // Uses the injected version
  }
  